module.exports = __webpack_public_path__ + "manifest.json";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=manifest.json!./manifest.json
// module id = 10
// module chunks = 1